import { PersonalManagersList } from '@my-account/const';
import { StateUtils } from '@spartacus/core';
import { PERSONAL_MANAGERS_LIST } from '../my-account-state';

export const LOAD_PERSONAL_MANAGERS_LIST = '[My Account] Load personal managers list';
export const LOAD_PERSONAL_MANAGERS_LIST_SUCCESS = '[My Account] Load personal managers list Success';
export const LOAD_PERSONAL_MANAGERS_LIST_FAIL = '[My Account] Load personal managers list Fail';
export const LOAD_PERSONAL_MANAGERS_LIST_RESET = '[My Account] Load personal managers list Reset';

export class LoadPersonalManagersList extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_PERSONAL_MANAGERS_LIST;

  constructor() {
    super(PERSONAL_MANAGERS_LIST);
  }
}

export class LoadPersonalManagersListSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_PERSONAL_MANAGERS_LIST_SUCCESS;

  constructor(public payload: PersonalManagersList) {
    super(PERSONAL_MANAGERS_LIST);
  }
}

export class LoadPersonalManagersListFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_PERSONAL_MANAGERS_LIST_FAIL;

  constructor(public payload: unknown) {
    super(PERSONAL_MANAGERS_LIST, payload);
  }
}

export class LoadPersonalManagersListReset extends StateUtils.LoaderResetAction {
  readonly type = LOAD_PERSONAL_MANAGERS_LIST_RESET;

  constructor() {
    super(PERSONAL_MANAGERS_LIST);
  }
}

export type PersonalManagersActions =
  | LoadPersonalManagersList
  | LoadPersonalManagersListSuccess
  | LoadPersonalManagersListFail
  | LoadPersonalManagersListReset;
